module.exports = {"首页":[{"name":"index","path":"/","type":"pages"}],"开始指南":[{"name":"test","path":"/test","desc":"测试"}],"组件":[{"desc":"视图组件","path":"/component","items":[{"desc":"Anglesign 角签","name":"anglesign","path":"/anglesign"}]}]}


//////////////////
// WEBPACK FOOTER
// ./examples/nav.config.json
// module id = ffz/
// module chunks = 3